import React, { useEffect, useRef, useState } from "react";

const Progressbar: React.FC<{ progress: number }> = ({ progress }) => {
  const [displayedProgress, setDisplayedProgress] = useState(0);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      setTimeout(() => setDisplayedProgress(progress), 10);
    } else {
      setDisplayedProgress(progress);
    }
  }, [progress]);

  return (
    <div className="w-full bg-very_light_pink h-0.5 relative">
      <div
        className="bg-white_grey text-xs leading-none absolute text-center text-white"
        style={{ width: "100%", top: 0, height: 2 }}
      ></div>
      <div
        className="bg-blue text-xs leading-none absolute h-1 text-center text-white"
        style={{
          width: `${displayedProgress}%`,
          top: -1,
          transition: "width 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      ></div>
    </div>
  );
};

export default Progressbar;
